import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { pluginCode } from 'drapcode-constant';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import ConstructorBuilder from './collection/derived-constructor/ConstructorBuilder';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { prepS3Url } from '../../common/utils/plugin_utils';
import { CONSTRUCTOR } from 'drapcode-constant';

export class Constructors extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.getPermissionFlags({ projectId });
    commonActions.loadCollectionChange();
  }

  render() {
    const { collections, match, actions, home, common, commonActions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const { loadProjectCollectionDetailPending, selectedCollection, permissionFlags } = collections;
    const { projectDetail, updatedCollections } = common;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    const { iPlugins } = home;
    const s3Url = prepS3Url(iPlugins, projectDetail, false);

    return (
      <CommonPageComponent parentClassName="">
        <CollectionHeaderNav
          label={types.CONSTRUCTOR}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionDetailPending && (
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionDetailPending}
              size="20px"
              color="#303453"
            />
          </div>
        )}
        {selectedCollection && (
          <ConstructorBuilder
            actions={actions}
            commonActions={commonActions}
            version={version}
            projectId={projectId}
            constructors={selectedCollection.constructors}
            collection={selectedCollection}
            collections={collections}
            plugins={iPlugins}
            s3Url={s3Url}
            deleteFlag={permissionsArray.includes(CONSTRUCTOR)}
            updatedCollections={updatedCollections}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Constructors);
